import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiMoreVertical } from "react-icons/fi";
import getIcon from "../../utils/getIcon";

const SiteOverviewStatistics = ({
  leadSummary = [],
  inquiry,
  permission,
  fromDate,
  toDate,
}) => {
  const dataArray = Array.isArray(leadSummary) ? leadSummary : [];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  if (permission?.pf_view !== 1) {
    return null;
  }

  return (
    <div className="row">
      {dataArray.map((val, index) => {
        return (
          <div key={index} className="col-xxl-3 col-md-3">
            <Link
         
              to={`/inquiry/inquiry-list?id=${val.moduleId}&leadTypeId=${val.LeadTypeId}`}
              state={{
                fromDate: fromDate,
                toDate: toDate,
              }}
              className="card stretch stretch-full short-info-card"
            >
              <div className="card-body">
                <div className="d-flex align-items-start justify-content-between">
                  <div className="d-flex gap-4 align-items-center">
                    <div className="avatar-text avatar-lg bg-gray-200 icon">
                      {getIcon("feather-shopping-bag", {
                        size: 24,
                        color: "blue",
                      })}
                    </div>
                    <div>
                      <div className="fs-4 fw-bold text-dark">
                        <span className="counter">{val?.TotalLeads ?? 0}</span>
                      </div>
                      <h3 className="fs-13 fw-semibold text-truncate-1-line">
                        {val?.LeadType ?? ""}
                      </h3>
                    </div>
                  </div>
                  <Link to="#" className="lh-1">
                    <FiMoreVertical className="fs-16" />
                  </Link>
                </div>

                <div className="pt-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="fs-12 fw-medium text-muted text-truncate-1-line"></div>
                    <div className="w-100 text-end">
                      <span className="fs-13 text-muted">
                        ₹{val?.TotalAmount ?? 0}
                      </span>
                    </div>
                  </div>

                  <div className="progress mt-2 ht-3">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${(val?.TotalLeads ?? 0) * 10}%`,
                        backgroundColor: "#4caf50",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
      {/* Card 1 */}
      {inquiry && inquiry[0] && (
        <div className="col-xxl-3 col-md-3">
          <Link
            to={`/inquiry/converted-inquiry-list?id=${inquiry[0].moduleId}`}
            state={{
              fromDate: fromDate,
              toDate: toDate,
            }}
            className="card stretch stretch-full short-info-card"
          >
            <div className="card-body">
              <div className="d-flex align-items-start justify-content-between">
                <div className="d-flex gap-4 align-items-center">
                  <div className="avatar-text avatar-lg bg-gray-200 icon">
                    {getIcon("feather-shopping-bag", {
                      size: 24,
                      color: "blue",
                    })}
                  </div>
                  <div>
                    <div className="fs-4 fw-bold text-dark">
                      <span className="counter">
                        {inquiry[0]?.TotalLeads ?? 0}
                      </span>
                    </div>
                    <h3 className="fs-13 fw-semibold text-truncate-1-line">
                      {inquiry[0]?.status ?? ""}
                    </h3>
                  </div>
                </div>
                <Link to="#" className="lh-1">
                  <FiMoreVertical className="fs-16" />
                </Link>
              </div>

              <div className="pt-2">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-12 fw-medium text-muted text-truncate-1-line"></div>
                  <div className="w-100 text-end">
                    <span className="fs-13 text-muted">
                      ₹{inquiry[0]?.TotalAmount ?? 0}
                    </span>
                  </div>
                </div>

                <div className="progress mt-2 ht-3">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${(inquiry[0]?.TotalLeads ?? 0) * 10}%`,
                      backgroundColor: "#4caf50",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )}
      {/* Card 2 */}
      {inquiry && inquiry[1] && (
        <div className="col-xxl-3 col-md-3">
          <Link
            to={`/inquiry/settled-list?id=${inquiry[1].moduleId}`}
            state={{
              fromDate: fromDate,
              toDate: toDate,
            }}
            className="card stretch stretch-full short-info-card"
          >
            <div className="card-body">
              <div className="d-flex align-items-start justify-content-between">
                <div className="d-flex gap-4 align-items-center">
                  <div className="avatar-text avatar-lg bg-gray-200 icon">
                    {getIcon("feather-shopping-bag", {
                      size: 24,
                      color: "blue",
                    })}
                  </div>
                  <div>
                    <div className="fs-4 fw-bold text-dark">
                      <span className="counter">
                        {inquiry[1]?.TotalLeads ?? 0}
                      </span>
                    </div>
                    <h3 className="fs-13 fw-semibold text-truncate-1-line">
                      {inquiry[1]?.status ?? ""}
                    </h3>
                  </div>
                </div>
                <Link to="#" className="lh-1">
                  <FiMoreVertical className="fs-16" />
                </Link>
              </div>

              <div className="pt-2">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-12 fw-medium text-muted text-truncate-1-line"></div>
                  <div className="w-100 text-end">
                    <span className="fs-13 text-muted">
                      ₹{inquiry[1]?.TotalAmount ?? 0}
                    </span>
                  </div>
                </div>

                <div className="progress mt-2 ht-3">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${(inquiry[1]?.TotalLeads ?? 0) * 10}%`,
                      backgroundColor: "#4caf50",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )}
      {/* Card 3 */}
      {inquiry && inquiry[2] && (
        <div className="col-xxl-3 col-md-3">
          <Link
            to={`/un-assigned-inquiry?id=${inquiry[2].moduleId}`}
            state={{
              fromDate: fromDate,
              toDate: toDate,
            }}
            className="card stretch stretch-full short-info-card"
          >
            <div className="card-body">
              <div className="d-flex align-items-start justify-content-between">
                <div className="d-flex gap-4 align-items-center">
                  <div className="avatar-text avatar-lg bg-gray-200 icon">
                    {getIcon("feather-shopping-bag", {
                      size: 24,
                      color: "blue",
                    })}
                  </div>
                  <div>
                    <div className="fs-4 fw-bold text-dark">
                      <span className="counter">
                        {inquiry[2]?.TotalLeads ?? 0}
                      </span>
                    </div>
                    <h3 className="fs-13 fw-semibold text-truncate-1-line">
                      {inquiry[2]?.status ?? ""}
                    </h3>
                  </div>
                </div>
                <Link to="#" className="lh-1">
                  <FiMoreVertical className="fs-16" />
                </Link>
              </div>

              <div className="pt-2">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-12 fw-medium text-muted text-truncate-1-line"></div>
                  <div className="w-100 text-end">
                    <span className="fs-13 text-muted">{0}</span>
                  </div>
                </div>

                <div className="progress mt-2 ht-3">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${(inquiry[2]?.TotalLeads ?? 0) * 10}%`,
                      backgroundColor: "#4caf50",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};

export default SiteOverviewStatistics;
